export const INITIAL_STATE = [
  {
    id: 'AAAA',
    type: 'Basic plan',
    plan_name: 'Monthly',
    amount: 'P 250.00',
    description: [
      { id: 'AAAA', description: '1 Sender name' },
      { id: 'BBBB', description: '5,000 Purchase Limit' },
      { id: 'CCCC', description: '50,000.00 Credit limit' },
      { id: 'DDDD', description: 'Free Technical support' },
    ],
    perks: '20% discount',
  },

  {
    id: 'BBBB',
    type: 'Basic plan',
    plan_name: 'Monthly',
    amount: 'P 250.00',
    description: [
      { id: 'AAAA', description: '1 Sender name' },
      { id: 'BBBB', description: '5,000 Purchase Limit' },
      { id: 'CCCC', description: '50,000.00 Credit limit' },
      { id: 'DDDD', description: 'Free Technical support' },
    ],
    perks: '20% discount',
  },
];

export const plan = [
  {
    id: 1,
    label: 'Basic Plan',
  },
  {
    id: 2,
    label: 'Business Plan',
  },
  {
    id: 3,
    label: 'Reseller Plan',
  },
  {
    id: 4,
    label: 'Business Plan',
  },
  {
    id: 5,
    label: 'Reseller Plan',
  },
  {
    id: 6,
    label: 'Reseller Plan',
  },
  {
    id: 7,
    label: 'Basic Plan',
  },
  {
    id: 8,
    label: 'Basic Plan',
  },
  {
    id: 9,
    label: 'Business Plan',
  },
];

export default {};
